export function addNavigationSpinnerEventListener() {
    const navLinks = document.querySelectorAll(".nav-item a");

    navLinks.forEach(link => {
        link.addEventListener("click", (event) => {
            // a jump within this page (anchor navigation) loads nothing
            if (link.hash && link.pathname === window.location.pathname) {
                return;
            }
            const spinner = link.querySelector(".spinner-border");
            if (spinner) {
                spinner.classList.remove("d-none");
            }
        });
    });
};